export default {"src":"/_next/static/media/Heart.86adb999.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};